export enum UserRole {
  superadmin = 'superadmin',
  admin = 'admin',
  expert = 'expert',
  member1 = 'member1',
  member2 = 'member2',
}

export enum DisplayMessages {
  UpdateDbSuccess = 'Updated successfully',
  UpdateLearningSuccessEn = 'Record labelled for learning',
  UpdateLearningSuccessKo = '학습용 레이블이 지정된 레코드',
  UpdatedLearningNormalEn = 'Record labelled for learning normal',
  UpdatedLearningNormalKo = '정상 학습을 위해 레이블이 지정된 레코드',
  RegisterSuccess = 'PUSH notification sent successfully',
  LabellingSuccess = 'Record labelled successfully',
  ServerError = 'Server error',
  MarkToBeDeleted = 'Deleted Noise record and redirected to human voice checking page',
  HumanVoice = 'Marked human voice checked',
  InProgress = 'in progress',
}

export interface ClassificationAccuracy {
  label: string;
  value: string;
}

export enum IdentificationFields {
  Undecided = 'Undecided',
  NoiseTypeMain = 'Noise Type Main',
  NoiseTypeSub = 'Noise Type Sub',
  ClassificationAccuracy = 'Classification Accuracy',
}

export interface DetailsPayload {
  noise_type_main?: string;
  noise_type_sub?: string;
  classification_accuracy?: string;
  customer_notification?: string;
  service_notification?: string;
  registration?: string;
  labelling?: string;
  learning?: string;
  learning_normal?: string;
}
export interface ServiceResult {
  seqNo: string;
  orgRepaName: string;
  repaDat: string;
  conDate: string;
}

export enum RemTimeColourCode {
  Unresolved = 'green',
  LessThanTwoDays = '#f5f507',
  LessThanOneDay = 'orange',
  DeadlineExceeded = 'red',
  Resolved = 'grey',
}

export interface SendAppBody {
  user_id: string;
  role: string;
  reason: string;
}

export interface PermissionChangeBody {
  userId: string;
  role: string;
  logUserId: string;
  logUserRole: string;
  reason: string;
  timezone: string;
}

export interface PermissionEditRoleBody {
  targetUserId: string;
  targetUserCurRole: string;
  targetUserEditedRole: string;
  logUserId: string;
  logUserRole: string;
  reason: string;
  timezone: string;
}

export interface UserLogBody {
  user_id: string;
  role: string;
  is_unusual: number;
  activity_data: string;
}

export enum lastDaysToSkip {
  noOfDays = 350,
}
export interface AIInfo {
  key: string;
  value: number;
  label: string;
}
export interface NoiseRecords {
  selected?: boolean;
  id?: number;
  di: string;
  filename: string;
  serial_number: string;
  model_code: string;
  device_type: string;
  s3_files: string[] | string;
  description: string;
  source: string;
  registration: boolean | string;
  start_time: string;
  presentTime: string;
  analysis_deadline: string;
  remainDays: string;
  noise_type_main: string;
  noise_type_sub: string;
  noise_type_main_label: string;
  noise_type_sub_label: string;
  analysis_result: AIInfo[] | string;
  ai: AIInfo[] | string;
  ai_result: string;
  customer_notification: string;
  classification_accuracy: string;
  service_notification: string;
  learning_error: string | boolean;
  learning_normal: string | boolean;
  presignedAudioUrl: string | string[];
  presignedSpectrogramUrl: string | string[];
  serv_res: ServiceResult[];
  labelling: boolean | string;
  remTimeColour: string;
  unittype: string;
}

export enum DeviceNames {
  REFRIGERATOR = 'refrigerator',
  AIRCONDITIONER = 'airconditoner',
  WASHER = 'washer',
}
